import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'
/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
    getRegionalProjectRequest: ['loading'],
    getRegionalProjectSuccess: ['response'],
    getRegionalProjectFailure: ['error'],
})

export const getRegionalProjectTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
    response: null,
    error: null,
    loading: null,
})

/* ------------- Reducers ------------- */
const getRegionalProjectRequest = state => {
    return state.merge({ success: null })
}

const getRegionalProjectSuccess = (state, { response }) => {
    return state.merge({
        success: true,
        error: false,
        response: response.data.data,
    })
}
const getRegionalProjectFailure = (state, { error }) => {
    const { response } = error
    return state.merge({
        success: false,
        error: true,
        response,
    })
}

export const reducer = createReducer(INITIAL_STATE, {
    [Types.GET_REGIONAL_PROJECT_REQUEST]: getRegionalProjectRequest,
    [Types.GET_REGIONAL_PROJECT_SUCCESS]: getRegionalProjectSuccess,
    [Types.GET_REGIONAL_PROJECT_FAILURE]: getRegionalProjectFailure,
})
